import React from 'react';
import PropTypes from 'prop-types';

import { isLaterThanWeekAfterToday } from '../../services/utils';

import DateColumn from './dateColumn';

const formatProductName = product => `${product.short_name} (${product.unit_name}, ${product.contract_type})`;

const ManageIndicesTable = ({
    products,
    indexClosestDate,
    indicesShedule,
    indices,
    isSuperUser,
    showPopup,
    frequencyType,
}) => {
    return (
        <div className="indices-table-container">
            {isSuperUser ? (
                <button
                    type="button"
                    onClick={() => showPopup(indexClosestDate, frequencyType)}
                    className="button indices-table-button"
                >
                    {`Add indices${frequencyType ? ` (${frequencyType})` : ''}`}
                </button>
            ) : null}
            {indicesShedule ? (
                <div className="indices-year-section">
                    <div className="indices-table-main-column">
                        <div className="indices-table-year">{indicesShedule.year}</div>
                        {products
                            ? products.map(p => (
                                  <div key={`product${p.id}`} className="indices-table-product">
                                      {formatProductName(p)}
                                  </div>
                              ))
                            : null}
                    </div>
                    <div className="indices-table-data-column">
                        {indicesShedule.selectedDates && indicesShedule.selectedDates.length ? (
                            indicesShedule.selectedDates.map(day =>
                                isLaterThanWeekAfterToday(day) ? null : (
                                    <DateColumn
                                        day={day}
                                        key={`date_${day}`}
                                        indices={indices}
                                        products={products}
                                        showPopup={() => showPopup(day, frequencyType)}
                                        isSuperUser={isSuperUser}
                                    />
                                ),
                            )
                        ) : (
                            <div className="no_schedule">Schedule is absent</div>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

ManageIndicesTable.propTypes = {
    showPopup: PropTypes.func.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    indexClosestDate: PropTypes.string,
    indicesShedule: PropTypes.shape({}).isRequired,
    indices: PropTypes.shape({}).isRequired,
    isSuperUser: PropTypes.bool.isRequired,
    frequencyType: PropTypes.string.isRequired,
};

export default ManageIndicesTable;



// WEBPACK FOOTER //
// ./source/components/manageIndices/manageIndicesTable.js